import { apiClient } from "../util/ApiClient";
import { store } from "../store";
import {
  NEW_PRIMARY_OWNER,
  ORGANIZATION_LOADED,
  ORGANIZATION_UPDATED
} from "./organization";
import { PROFILE_PATH, CHANGE_PASSWORD_PATH } from "../config/Api";

export const USER_LOADED = "USER_LOADED";
export const userLoaded = user => ({
  type: USER_LOADED,
  user
});

export const USER_UPDATED = "USER_UPDATED";
export const userUpdated = user => ({
  type: USER_UPDATED,
  user
});

const userInitialState = {
  first_name: null,
  last_name: null,
  email: null,
  is_owner: false,
  is_primary_owner: false,
  capabilities: [],
  organization: null
};
export const userReducer = (state = userInitialState, action) => {
  switch (action.type) {
    case USER_UPDATED:
    case USER_LOADED:
      return {
        ...action.user,
        organization: state.organization || action.user.organization
      };
    case ORGANIZATION_LOADED:
    case ORGANIZATION_UPDATED:
      return {
        ...state,
        organization: action.organization
      };
    case NEW_PRIMARY_OWNER:
      return {
        ...state,
        is_primary_owner: state.uuid === action.payload
      };
    default:
      return state;
  }
};

export const loadUser = () => {
  return apiClient()
    .get(PROFILE_PATH)
    .then(response => response.data);
};

export const updateUser = newUser => {
  return apiClient()
    .post(PROFILE_PATH, newUser)
    .then(response => {
      const user = response.data;
      store.dispatch(userUpdated(user));
      return user;
    });
};

export const updateBasicInfo = (first_name, last_name, email) => {
  return updateUser({
    first_name,
    last_name,
    email
  });
};

export const updateReimbursementPreferences = reimbursement_notifications => {
  return updateUser({
    user: {
      reimbursement_notifications
    }
  });
};

export const changePassword = (old_password, password, password_confirm) => {
  return apiClient().post(CHANGE_PASSWORD_PATH, {
    old_password,
    password,
    password_confirm
  });
};



// WEBPACK FOOTER //
// ./frontend/src/actions/user.js